<!--
Author: jiangli
Date: 2024-05-07
Desc: 组合定投
 -->
<template>
    <div class="pt20 pb20 pl20 pr25 pr20">
        <div v-for="(item, index) in plans" :key="index">
            <div
                class="bc_FFF6F6 bor_b_FFD8D8 pt35 pb35 pl16 pr16 fs20 c_333 br4 flex between hcenter"
            >
                <div class="flex hcenter">
                    <div class="mr12 bold">{{ item.par1 }}</div>
                    <div class="flex hcenter pointer" v-on:click="item.expand = !item.expand">
                        <div class="c_1890FF fs16">{{ item.expand ? "收起" : "展开" }}</div>
                        <img
                            src="../../assets/img/triangle-down.svg"
                            class="w14 h10 ml4"
                            :class="[item.expand ? '' : 'rotate180']"
                        />
                    </div>
                </div>
                <div class="bc_E60012 c_ffffff fs14 lin22 pl25 pr25 pt10 pb10" v-on:click="goPlan">
                    立即定投
                </div>
            </div>
            <div v-show="item.expand" class="pt20 pb40 flex between">
                <div>
                    <div class="flex hcenter mb20">
                        <div class="w3 h16 bc_E60012 mr6"></div>
                        <div class="fs18">我的资产</div>
                    </div>
                    <div class="bc_F9F9F9 w356 h320">
                        <div :id="'echart' + index" class="w356 h320"></div>
                    </div>
                </div>

                <div>
                    <div class="flex hcenter mb20">
                        <div class="w3 h16 bc_E60012 mr6"></div>
                        <div class="fs18">组合特色</div>
                    </div>
                    <div class="bc_F9F9F9 pt20 pl16 pr16 pb64 mb20 fs18 w784 border-box">
                        {{ item.par2 }}
                    </div>
                    <div class="flex hcenter mb20">
                        <div class="w3 h16 bc_E60012 mr6"></div>
                        <div class="fs18">适宜对象</div>
                    </div>
                    <div class="bc_F9F9F9 pt20 pl16 pr16 pb64 mb20 fs18 w784 border-box">
                        {{ item.par2 }}
                    </div>
                </div>
            </div>
        </div>
        <footerQuestions :warning-html="warningHtml" class="mt40"></footerQuestions>
    </div>
</template>

<script>
import footerQuestions from "@/components/layout/footerQuestions.vue";
import * as echarts from "echarts";
export default {
    name: "Combofund",
    components: {
        footerQuestions
    },
    data() {
        return {
            warningHtml:
                "1、大成基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。",
            plans: [
                {
                    par1: "享天伦养老计划1(稳健型)",
                    par2: "组合以较低风险的债券及货币基金为主，同时保留一部分指数基金，在降低风险的同时追求稳健收益。",
                    par3: "适合即将退休或低风险承受能力的投资者。",
                    arr: [
                        {
                            par4: "大成债券",
                            par5: "30"
                        },
                        {
                            par4: "大成添利宝货币",
                            par5: "30"
                        },
                        {
                            par4: "大成沪深300指数",
                            par5: "40"
                        }
                    ],
                    expand: false
                },
                {
                    par1: "享天伦养老计划2(稳健型)",
                    par2: "组合以较低风险的债券及货币基金为主，同时保留一部分指数基金，在降低风险的同时追求稳健收益。",
                    par3: "适合即将退休或低风险承受能力的投资者。",
                    arr: [
                        {
                            par4: "大成债券",
                            par5: "10"
                        },
                        {
                            par4: "大成添利宝货币",
                            par5: "50"
                        },
                        {
                            par4: "大成沪深300指数",
                            par5: "40"
                        }
                    ],
                    expand: false
                }
            ]
        };
    },

    created() {},

    mounted() {
        this.initChart();
    },

    methods: {
        // 初始化饼图
        initChart() {
            this.plans.forEach((item, index) => {
                let myChart = echarts.init(document.getElementById("echart" + index));
                let funds = [];
                item.arr.forEach((item1) => {
                    funds.push({
                        value: item1.par5,
                        name: item1.par4
                    });
                });
                let option = {
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}（{d}%）"
                    },
                    series: [
                        {
                            type: "pie",
                            hoverAnimation: false,
                            color: ["#ffb52b", "#f97170", "#7189fe"],
                            data: funds,
                            radius: ["10%", "60%"],
                            label: {
                                normal: {
                                    show: true,
                                    position: "inside", // 标签显示的位置，'outside' 表示标签在扇形外侧
                                    formatter: "{d}%" // 标签文本格式器
                                }
                            }
                        },
                        {
                            type: "pie",
                            hoverAnimation: false,
                            color: ["#ffb52b", "#f97170", "#7189fe"],
                            data: funds,
                            radius: ["10%", "60%"],
                            label: {
                                normal: {
                                    show: true,
                                    position: "outside", // 标签显示的位置，'outside' 表示标签在扇形外侧
                                    formatter: "{b}" // 标签文本格式器
                                },
                                emphasis: {
                                    show: true,
                                    formatter: "{b}"
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true // 是否显示标签的引导线
                                }
                            },
                            labelLayout: {
                                hideOverlap: false
                            }
                        }
                    ]
                };
                myChart.setOption(option);
            });
        },
        // 设置组合定投
        goPlan() {
            this.$util.fundRiskCheck(this, {}, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: "59", isCom: true });
                    sessionStorage.setItem("generalbuy", JSON.stringify(_x));
                    this.$router.push({ name: "generalbuy" });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
